import { Reorder, motion } from "framer-motion";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { Icon, Label } from "semantic-ui-react";
import { golfHelpers } from "../helpers/golfHelpers";

export default function LineupBuilder({ items, groupCount, propsToShow, handleUpdateArray, golfer_partners, selectedRoundType, allowSorting }) {

  const [currentItems, setCurrentItems] = useState([]);
  const [draggingItem, setDraggingItem] = useState();

  const maxCount = 1000

  const _currentItems = useMemo(() => {
    _.forEach(items, (item, itemKey) => {
      if (!item.courseRoundHandicap) {
        item.courseRoundHandicap = item.courseHandicaps['nqbO2xbCJeZNrS38aDrB']
      }
    })
    return items
  }, [items]);

  useEffect(() => {
    setCurrentItems(_currentItems)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_currentItems]);

  const handle_onReorder = (sortedItems) => {
    try {
      if (!_.isEmpty(sortedItems)) {
        golfHelpers.ammendLineupGroups(sortedItems, groupCount)
        setCurrentItems([...sortedItems]);
        handleUpdateArray && handleUpdateArray([...sortedItems])
      }
    } catch (error) {
      console.log('e', error)
    }
  };

  // group items by groupNumber or by chunk size
  const groups = currentItems && _.some(currentItems, "groupNumber")
    ? _.groupBy(currentItems, "groupNumber")
    : _.chunk(currentItems, groupCount || currentItems.length);

  const lbls_props = (item) => {
    const lbls = []
    _.forEach(propsToShow, (prop) => {
      if (item[prop]) {
        lbls.push(<Label circular color="grey" size="tiny" >{item[prop]}</Label>)
      }
    })
    return lbls
  }

  const item_reorder = (item, idx, groupNumber) => {
    const { firstName, lastName, name, key, _notPlaying, position } = item ?? {}
    const parts = golfer_partners?.[key]
    const { partners } = parts ?? {}
    let title = ''
    if (partners) {
      _.forEach(partners, (partner, partKey) => {
        const { firstName, lastName, rounds } = partner ?? {}
        if (rounds) {
          _.forEach(rounds, (round, roundKey) => {
            if (roundKey === selectedRoundType) {
              const { record } = round ?? {}
              title += firstName + ' ' + lastName + ': ' + record.wins + '/' + record.losses + '/' + record.ties + '\n'
            }
          })
        }
      })
    }
    return <Reorder.Item
      title={title}
      key={item.key}
      value={item}
      as={motion.div}
      drag={allowSorting}
      onDragStart={() => setDraggingItem({ groupKey: groupNumber, itemKey: key })}
      onDragEnd={() => setDraggingItem(null)}
      dragConstraints={{ left: 0, right: 0 }}
      whileDrag={{
        scale: 1.05,
        boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
      }}
      className={`group-item group-num-${idx + 1}`}
    >
      <Label className={`lbl-group ${draggingItem?.itemKey === key ? 'lbl-drag' : ''}`} size="small">
        <Label size="tiny" className={`lbl-group-type lbl-group-type-${groupNumber % 2 === 0 ? 'even' : 'odd'} ${draggingItem?.itemKey === key ? 'lbl-drag' : ''} ${position >= maxCount ? 'np' : ''}`}><Icon name='hashtag' />{groupNumber + 1}</Label>
        <Label size="tiny" color="blue">{item.position + 1}</Label>
        {name || `${firstName} ${lastName}`}
        {propsToShow && lbls_props(item)}
      </Label>
    </Reorder.Item>
  }

  const item_groupItems = (group, groupKey) => (
    _.map(group, (item, idx) => (
      item_reorder(item, idx, _.parseInt(groupKey))
    ))
  )

  let cn = 'sort-list-container lup-' + groupCount
  if (propsToShow) {
    cn += ' pts'
  }

  return (
    <Reorder.Group
      axis="y"
      values={currentItems}
      onReorder={handle_onReorder}
      className={cn}
    >
      {_.flatMap(groups, (group, groupKey) =>
        item_groupItems(group, groupKey)
      )}
    </Reorder.Group>
  );
}
